/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { V as Variants, O as Orientation } from './constants-c94b83bd.js';

const DHL_TABLE_VARIANTS = {
    STRIPED: Variants.striped,
    REGULAR: Variants.regular,
};
const DHL_TABLE_BORDER_COLOR = {
    GRAY: "gray",
    RED: "red",
    BLACK: "black",
};
const DHL_TABLE_MOBILE_VARIANT = {
    HORIZONTAL: Orientation.horizontal,
    VERTICAL: Orientation.vertical,
};
const DHL_TABLE_FOOTER_TEXT_ALIGN = {
    LEFT: Orientation.left,
    CENTER: Orientation.center,
    RIGHT: Orientation.right,
};
const DHL_TABLE = {
    VARIANT: DHL_TABLE_VARIANTS,
    BORDER_COLOR: DHL_TABLE_BORDER_COLOR,
    MOBILE_VARIANT: DHL_TABLE_MOBILE_VARIANT,
    FOOTER_TEXT_ALIGN: DHL_TABLE_FOOTER_TEXT_ALIGN,
};

export { DHL_TABLE as D };

//# sourceMappingURL=constants-1589b848.js.map